import {
  CLOSEOUT_CATS_SET,
  CLOSEOUT_SET,
  CLOSEOUT_CONTRIBS_SET,
  CLOSEOUT_CONTRIB_SET,
  CLOSEOUT_PERCENTAGE_SET,
  CLOSEOUT_MANUALS_SET,
  CLOSEOUT_MANUAL_SET,
  CLOSEOUT_MANUAL_UPDATE,
  CLOSEOUT_MANUAL_DELETE,
} from 'components/admin/projects/details/project-closeout/store/action-types';

const initialState = {
  closeoutCats: [],
  closeout: null,
  closeoutContribs: [],
  currentPage: 1,
  total: 0,
  pageSize: 25,
  closeoutPercentage: 0,
  closeoutManuals: [],
  closeoutManualsCurrentPage: 1,
  closeoutManualsTotal: 0,
  closeoutManualsPageSize: 25,
  closeoutManual: null,
};

export default function projectCloseoutDataReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case CLOSEOUT_CATS_SET:
      return {
        ...state,
        closeoutCats: action.payload,
      };

    case CLOSEOUT_SET:
      return {
        ...state,
        closeout: action.payload,
      };

    case CLOSEOUT_CONTRIBS_SET:
      return {
        ...state,
        ...action.payload,
      };

    case CLOSEOUT_CONTRIB_SET:
      return {
        ...state,
        closeoutContribs: state.closeoutContribs.map((closeoutContrib) => {
          return closeoutContrib.id === action.payload.id
            ? action.payload
            : closeoutContrib;
        }),
      };

    case CLOSEOUT_PERCENTAGE_SET:
      return {
        ...state,
        closeoutPercentage: action.payload,
      };

    case CLOSEOUT_MANUALS_SET:
      return {
        ...state,
        ...action.payload,
      };

    case CLOSEOUT_MANUAL_SET:
      return {
        ...state,
        closeoutManual: action.payload,
        closeoutManuals: [action.payload, ...state.closeoutManuals],
      };

    case CLOSEOUT_MANUAL_UPDATE:
      return {
        ...state,
        closeoutManual: action.payload,
        closeoutManuals: state.closeoutManuals.map((clsManual) => {
          return clsManual.id === action.payload.id
            ? action.payload
            : clsManual;
        }),
      };

    case CLOSEOUT_MANUAL_DELETE:
      return {
        ...state,
        closeoutManuals: state.closeoutManuals.filter((clsManual) => {
          return clsManual.id !== action.payload;
        }),
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-closeout/store/reducers.data.js